import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { EULA } from 'src/app/models/eula.model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { EulaService } from 'src/app/services/eula/eula.service';

@Component({
  selector: 'app-eula-modal',
  templateUrl: './eula-modal.page.html',
  styleUrls: ['./eula-modal.page.scss'],
})
export class EULAModalPage implements OnInit {
  eula: EULA;

  readonly: boolean = false;

  submitting: boolean;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private eulaService: EulaService,
    private authentication: AuthenticationService,
    private modalController: ModalController
  ) { 
    this.translate.setDefaultLang("en");
    this.translate.use(this.translate.getBrowserLang() || "en");
  }

  ngOnInit() { 
    this.submitting = false;
  }

  acceptEULA(accept: boolean) {
    this.submitting = true;
    if(accept) { // Get user to accept EULA
      this.eulaService.acceptEULA(this.eula.id).subscribe(() => {
        this.modalController.dismiss().then(() => {
          this.router.navigate(['/home/dashboard']).then(() => {
            location.reload();
          });
        });
      });
    } else {
      this.authentication.logout().then(() => {
        this.modalController.dismiss().then(() => {
          this.router.navigate(['/login']);
        });
      });
    }
  }

  async closeModal() {
    await this.modalController.dismiss();
  }
}
